
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'ストーリー',
	'noDashboardFound': 'ストーリーを取得できません。 存在しないか、または表示するのに必要な権限がありません。',
	'noDashboardCapability': 'ストーリーを使用する機能がありません',
	'noDashboardPermision': 'このストーリーを表示するための十分な特権がありません。',
	'defaultName': '新しいストーリー',
	'storyProperties': 'ストーリーのプロパティー',
	'createAvDataStoryLabel': 'ストーリー',
	'createAvSlideShowLabel': 'スライド・ショー',
	'createAvPanAndZoomLabel': 'ガイド付き',
	'dashboard_save_success': 'ストーリーが保存されました。',
	'cmEmptySelection': 'ストーリーは削除されました。 新しいストーリーとして保存してみてください。',
	'createStoryTitle': 'ストーリーの作成',
	'transitionStyleTitle': '遷移スタイル',
	'createButton': '作成',
	'cancelButton': 'キャンセル',
	'dashboardResetTitle': 'ストーリーのリセット',
	'dashboardResetMessage': 'このストーリーに適用されたすべての変更をリセットしますか?',
	'dashboardResetToast': 'ストーリーがリセットされました。',
	'filter_drag_and_drop_all_tabs': 'すべてのシーンをフィルターにかけるには、データをここにドラッグ・アンド・ドロップします。',
	'filter_drag_and_drop_current_tab': 'このシーンをフィルターにかけるには、データをここにドラッグ・アンド・ドロップします。',
	'filterIconLabel_Global': 'すべてのシーン',
	'filterIconLabel_Tab': 'このシーン',
	'filterIconTooltip_Global': 'すべてのシーン',
	'filterIconTooltip_Tab': 'このシーン',
	'filterOverflowMenu_Global': '「すべてのシーン」オーバーフロー・メニュー',
	'filterOverflowMenu_Tab': '「このシーン」オーバーフロー・メニュー',
	'renameScene': 'シーンのリネーム',
	'duplicateScene': 'シーンの複製',
	'deleteScene': 'シーンの削除',
	'editTimelineHighlight': 'ハイライトの編集',
	'deleteTimelineHighlight': 'ハイライトの削除',
	'filter_includesAll': 'すべて含める',
	'timeline_highlight_moved_to': 'タイム・ライン・ハイライト %{id} が %{time} に移動されました',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': '選択',
	'newDefaultStoryName': 'ストーリー: %{modelName}',
	'exportLabel': '保存',
	'exportAsLabel': '名前を付けて保存:',
	'exportDialogTitle': 'ストーリーとして保存',
	'exportDialogFooter': '「保存」および「キャンセル」ボタン',
	'loadAfterExportLabel': '保存後にストーリーを開く',
	'selectTemplateLabel': 'テンプレートの選択',
	'outOfBoundsWarningMessage': 'ダッシュボード・ウィジェットによってはグリッドの外側にあるものもあり、エクスポート後に正しく表示されない場合があります。',
	'emptyExploreCardsWarningMessage': 'ストーリーとして保存中に空のカードは削除されました。',
	'dashboard_export_success': 'ダッシュボードが正常にストーリーとして保存されました。',
	'explore_export_success': '閲覧ビューが正常にストーリーとして保存されました。',
	'toastUpgradeDone': 'ストーリーがアップグレードされました。 今すぐ保存して、最適なパフォーマンスを維持してください。。',
	'navigationMarker': 'ナビゲーション・マーカー',
	'navigateMarkers': 'ナビゲート・マーカー',
	'navNextMarker': '次のマーカー',
	'navPrevMarker': '前のマーカー',
	'navPrevMarkerAbbreviated': '前のマーカー',
	'timelineSettingsButton': '再生オプション',
	'autoPlay': 'すべてのシーンを再生',
	'loop': 'ループ',
	'refreshData': '始動時に更新',
	'slideshowLabel': 'スライド・ショー',
	'panAndZoomLabel': 'ガイド付き',
	'slideShowLayoutLabel': 'スライド・ショー・レイアウト',
	'panAndZoomLayoutLabel': 'ガイド付きレイアウト',
	'panAndZoomLayoutFooter': 'ガイド付きレイアウトでは、一連のシーンが単一のキャンバス上に表示されます。 このタイプのストーリーを実行すると、各シーンが順番にズームされ、パンされていきます。 一方、スライド・ショー・レイアウトでは、各シーンが新しいキャンバス上に表示されます。 3 つのシーンを線で接続したガイド付きレイアウトを使用すると、横方向に連続するシーンを作成できます。 これはタイムラインを表す場合に役立ちます。',
	'PanAndZoomLayout1': '長方形状に並べられた 5 つのシーン',
	'PanAndZoomLayout2': '右上がりの階段状に並べられた 4 つのシーン',
	'PanAndZoomLayout3': '長方形状に並べられた 6 つのシーン',
	'PanAndZoomLayout4': '長方形状に並べられた 7 つのシーン (上側に小さなシーン 6 つ、下側に大きなシーン 1 つ)',
	'PanAndZoomLayout5': '3 つのシーン (上側に小さなシーン 2 つ、下側に大きなシーン 1 つ)',
	'PanAndZoomLayout6': '横方向に連続して並べられた 4 つのシーン',
	'pageSelectWarning': 'シーンを選択してください。',
	'noSceneTransitionLabel': 'なし',
	'sceneTransitionPropertyLabel': 'シーンの遷移',
	'animatedPathSceneTransitionLabel': 'アニメーションのパス',
	'sweepSceneTransitionLabel': 'スイープ',
	'storyTypeLabel': 'ストーリー・タイプ',
	'layoutLabel': 'レイアウト',
	'tabName_animation': 'アニメーション',
	'propAniAnimation': 'アニメーション',
	'propAniTypeEntrance': '開始アニメーション',
	'propAniDirectionIn': '開始方向',
	'propAniTypeExit': '終了アニメーション',
	'propAniDirectionOut': '終了方向',
	'propAniDirection': '方向',
	'propAniEntrance': '開始効果',
	'propAniTypeEntranceSlideIn': 'スライドイン',
	'propAniTypeEntranceFadeIn': 'フェードイン',
	'propAniTypeEntrancePivotIn': 'ピボットイン',
	'propAniTypeEntranceScaleIn': 'スケールイン',
	'propAniTypeEntranceShrinkIn': 'シュリンクイン',
	'propAniDirectionInLeft': '左から',
	'propAniDirectionInRight': '右から',
	'propAniDirectionInTop': '上から',
	'propAniDirectionInBottom': '下から',
	'propAniExit': '終了',
	'propAniTypeExitSlideIn': 'スライドアウト',
	'propAniTypeExitFadeIn': 'フェードアウト',
	'propAniTypeExitPivotOut': 'ピボットアウト',
	'propAniTypeExitScaleIn': 'スケールアウト',
	'propAniTypeExitExpandOut': 'エクスパンドアウト',
	'propAniDirectionOutLeft': '左へ',
	'propAniDirectionOutRight': '右へ',
	'propAniDirectionOutTop': '上へ',
	'propAniDirectionOutBottom': '下へ',
	'propAniEntranceTime': '開始 (秒):',
	'propAniExitTime': '終了 (秒):',
	'animationNoEntranceText': 'このウィジェットがシーンの最初の場合、開始アニメーションは表示されません。',
	'animationNoExitText': 'このウィジェットがシーンの最後の場合、終了アニメーションは表示されません。',
	'propAniTypeDataEntrance': 'データの開始効果',
	'propAniRevealDuration': 'エントリー・アニメーション期間',
	'timelineAnimationProperties': 'アニメーション・プロパティーを開く',
	'scenesPropertiesSection': 'シーン',
	'editStoryCoachMarkTitle': 'ストーリーの編集',
	'editStoryCoachMarkContents': 'このストーリーを編集するには、鉛筆アイコンをクリックします。',
	'addDataStoryCoachMarkContents': 'データ・パネルのデータをストーリーにドラッグ・アンド・ドロップします。',
	'expandSceneCoachmarkTitle': 'タイムラインを開く',
	'expandSceneCoachmarkContents': '時刻と期間に基づいてオブジェクト可視性を調整することにより、シーンをアニメーションにします。',
	'overviewCoachmarkTitle': 'シーンの概要',
	'overviewCoachmarkContents': 'ストーリーの開始時と終了時にシーンの概要を使用して、すべてのシーンの全体像を示すことができます。 シーンの概要から、シーンをクリックしてドラッグして別のシーンと入れ替えることができます。 シーンの概要は、ストーリーのプロパティーで表示または非表示にできます。',
	'animatedPathCoachmarkTitle': 'アニメーションのパス',
	'animatedPathCoachmarkContents': 'あるシーンから別のシーンまでオブジェクトをアニメーション表示するには、そのオブジェクトを含むシーンを複製します。 次に、複製したオブジェクトを新しいシーンで移動、サイズ変更、または回転させます。',
	'propShowStoryOverviewFirstSlide': '開始時にすべてのシーンを表示',
	'propShowStoryOverviewLastSlide': '終了時にすべてのシーンを表示',
	'storySceneSingleCountLabel': '1 個のシーン',
	'storySceneCountLabel': '%{count} 個のシーン',
	'storySceneRangeCountLabel': 'シーン %{index} / %{count}',
	'storySceneExpand': 'タイムラインを開く',
	'storySceneActionMenu': 'シーン・オプション・メニューの起動',
	'timelineRightContainerLabel': 'タイムライン・ボタン・コントロール・グループ',
	'timelineViewLabel': 'タイムライン',
	'timelineZoomFit': '画面に合わせてズーム',
	'timelineZoomIn': '拡大',
	'timelineZoomOut': '縮小',
	'timelinePositionIndicator': '%{position} のタイムライン位置標識',
	'timelinePositionIndicatorMoveLeftTo': 'タイムライン位置標識を %{position} まで左に移動',
	'timelinePositionIndicatorMoveRightTo': 'タイムライン位置標識を %{position} まで右に移動',
	'sceneStart': '最初のシーンの %{position} にジャンプ',
	'sceneEnd': '最後のシーンの %{position} にジャンプ',
	'timelineHighlightTitle': 'ハイライト',
	'addTimelineHighlight': 'ハイライトの追加',
	'addSceneBtnTitle': 'デフォルト・テンプレートを使用して新しいシーンを追加',
	'addSceneChevronBtnTitle': 'シーン・テンプレートの選択',
	'timelinePlay': '再生',
	'timelinePause': '一時停止',
	'sceneNavigation': 'シーン・ナビゲーション',
	'navNextScene': '次のシーン',
	'navPrevScene': '前のシーン',
	'navPrevSceneAbbreviated': '前のシーン',
	'navExitFullScreen': 'フルスクリーンの終了',
	'navToggleOverview': '概要の切り替え',
	'rowNumber': '行 %{number}',
	'overviewBtnLabel': '概説',
	'sceneListStart': '概説の開始',
	'sceneListEnd': '概説の終了',
	'timelineLeftHandle': '%{name} の左のハンドル',
	'timelineRightHandle': '%{name} の右のハンドル',
	'timelineLeftHandleNoTitle': '左のハンドル',
	'timelineRightHandleNoTitle': '右のハンドル',
	'timelineMoveLeft': '%{object} を左へ移動',
	'timelineMoveRight': '%{object} を右へ移動',
	'timelineMoveWidget': 'タイム・ライン・ウィジェットが %{newStartTime} および %{newEndTime} に移動されました',
	'timelineMoveWidgetStartTime': 'タイム・ライン・ウィジェットの開始時刻が %{newStartTime} に変更されました',
	'timelineMoveWidgetEndTime': 'タイム・ライン・ウィジェットの終了時刻が %{newEndTime} に変更されました',
	'timelineMoveWidgetDown': 'タイム・ライン・ウィジェットが下に移動されました',
	'timelineMoveWidgetUp': 'タイム・ライン・ウィジェットが上に移動されました',
	'addSceneTitle': 'シーンの追加',
	'blankSceneLayout': '空白',
	'titleSceneLayout': 'タイトルとサブタイトル',
	'sceneLayout1': 'タイトルと視覚化 1 つとその横にテキスト',
	'sceneLayout2': 'タイトルと視覚化 1 つ',
	'sceneLayout3': 'タイトルと視覚化 2 つ',
	'sceneLayout4': '多目的',
	'sceneLayout5': 'タイトルなし、視覚化 1 つとその横にテキスト',
	'sceneLayout6': '多目的 2 × 2',
	'sceneLayout7': '多目的左 2 右 1',
	'sceneLayout8': '多目的左 1 右 2',
	'sceneLayout9': '多目的上 1 下 2',
	'sceneLayout10': '多目的上 2 下 1',
	'sceneLayout11': '多目的上 4 下 1',
	'sceneLayout12': '多目的左側上 1 下 1 右側上 2 × 2 下 1',
	'titleWidgetPlaceholderText': 'ここにタイトルを入力してください',
	'subtitleWidgetPlaceholderText': 'ここにサブタイトルを入力してください',
	'createStoryViewTitle': 'ストーリーの作成',
	'defaultStoryName': '新しいストーリー',
	'screenshot_label': 'ストーリー %{title}',
	'screenshot_label_scene': 'ストーリー %{title} のシーン %{sceneTitle}',
	'filmstripHandleOpenLabel': 'シーン・セレクターを開く',
	'filmstripHandleCloseLabel': 'シーン・セレクターを閉じる'
});
